import { Flex } from '@chakra-ui/layout';
import { Button, InputLeftAddon, InputGroup as ChakraInputGroup } from '@chakra-ui/react';
import { Select } from '@chakra-ui/select';
import React from 'react';
import { useForm } from 'react-hook-form';
import InputGroup from '../../../../components/InputGroup';

export function Filtro({ dataFilter, fornecedores }) {
  const { register, handleSubmit, formState } = useForm();

  function onSubmit(filter) {
    console.log(filter);
    dataFilter(filter);
  }

  return (
    <Flex
      paddingInline={'2rem'}
      marginBlock={'2rem'}
      flexDir={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={5}
      as={'form'}
      onSubmit={handleSubmit(onSubmit)}>
      <Flex gap={2}>
        <InputGroup label={'N. Pedido'} {...register('nPedido')} name={'nPedido'} id={'nPedido'} />
        <InputGroup type={'date'} label={'De'} {...register('dataDe')} name={'dataDe'} />
        <InputGroup type={'date'} label={'Ate'} {...register('dataAte')} name={'dataAte'} />
        <ChakraInputGroup>
          <InputLeftAddon children="Pendente" />
          <Select borderLeftRadius={'0'} {...register('pendente')} defaultValue={''}>
            <option value="">Selecione</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </Select>
        </ChakraInputGroup>
        <ChakraInputGroup>
          <InputLeftAddon children="Fornecedor" />
          <Select borderLeftRadius={'0'} {...register('fornecedor')} defaultValue={''}>
            <option value="">Todos</option>
            {fornecedores.map((fornecedor) => (
              <option key={fornecedor.value} value={fornecedor.value}>
                {fornecedor.label}
              </option>
            ))}
          </Select>
        </ChakraInputGroup>
      </Flex>
      <Button
        bgColor={'#378BBF'}
        width={'200px'}
        color={'white'}
        type={'submit'}
        _hover={{
          filter: 'brightness(0.8)'
        }}
        isLoading={formState.isSubmitting}>
        Filtrar
      </Button>
    </Flex>
  );
}
